import React, { useEffect, useState } from 'react'
import { Motif } from '../../types/motifs'
import { useContextSelectedMotifs } from '../../contexts/selectedMotifContext'
import { useTranslation } from 'react-i18next'
import SVG from 'react-inlinesvg'
import { isMobile } from 'react-device-detect'
import { cn } from '../../utils/cn'

interface Props {
  motif: Motif
}

const MotifSelector = ({ motif }: Props) => {
  const { t } = useTranslation()
  const { selectedMotifs, isSelected, selectMotif, deselectMotif } = useContextSelectedMotifs()
  const [numberedText, setNumberedText] = useState<string | false>(false)
  const [isMotifSelected, setIsMotifSelected] = useState<boolean>(false)

  useEffect(() => {
    setIsMotifSelected(isSelected(motif.id))
  }, [selectedMotifs.length])

  useEffect(() => {
    switch (selectedMotifs.length) {
      case 0:
        setNumberedText('maxFourMotifs')
        break
      case 1:
        setNumberedText('threeMoreMotifs')
        break
      case 2:
        setNumberedText('twoMoreMotifs')
        break
      case 3:
        setNumberedText('oneMoreMotif')
        break
      case 4:
        setNumberedText(false)
        break
    }
  }, [selectedMotifs.length])

  return (
    <div className="selectorButtonWrapper">
      <button
        className={cn(
          'group relative bottom-0 left-0 flex h-[90px] items-center gap-[5px] rounded-[12px] border-none p-0 text-black70 [align-self:start] [background:none] [grid-column:1_/_1] [grid-row:2_/_2] disabled:cursor-not-allowed',
          { mobile: isMobile },
        )}
        onClick={event => {
          event.stopPropagation()
          if (isMotifSelected) {
            deselectMotif(motif.id)
          } else {
            selectMotif(motif)
          }
        }}
        disabled={selectedMotifs.length === 4 && !isMotifSelected}
      >
        <div
          className={cn(
            'flex min-h-[44px] min-w-[44px] items-center justify-center rounded-[50%] group-disabled:opacity-30 sm:min-h-[70px] sm:min-w-[70px] md:min-h-[80px] md:min-w-[80px] xl:min-h-[90px] xl:min-w-[90px] xxl:min-h-[112px] xxl:min-w-[112px] [&.add]:bg-red [&.remove]:border [&.remove]:border-solid [&.remove]:border-black [&.remove]:bg-transparent',
            { remove: isMotifSelected, add: !isMotifSelected },
          )}
        >
          {isMotifSelected ? (
            <SVG className="h-[45%] w-[45%] text-red" src="/icons/minus.svg" />
          ) : (
            <SVG className="h-[45%] w-[45%] text-white" src="/icons/plus.svg" />
          )}
        </div>
        <div className="ml-[1rem] text-left font-approach-semi-bold text-[18px] font-normal leading-[30px] tracking-[0%]">
          <div className="selector-text mr-[-1rem] text-red">
            {selectedMotifs.length === 4
              ? t('maxMotifsReached')
                  .split(';')
                  .map((part, index, array) => (
                    <React.Fragment key={index}>
                      {part}
                      {index < array.length - 1 && <br />}
                    </React.Fragment>
                  ))
              : isMotifSelected
              ? t('removeThisMotif')
              : t('selectThisMotif')}
          </div>
          {numberedText && <div className="selector-numbered-text">{t(numberedText)}</div>}
        </div>
      </button>
    </div>
  )
}

export default MotifSelector
